<template>
  <b-sidebar v-model="showModal" bg-variant="white" right backdrop shadow>
    <div class="text-center">
      <b-card-text class="mt-2 h4 color-inherit text-reset">
        Change number of licenses
      </b-card-text>
      <b-card-text class="mt-1 h6 color-inherit text-reset">
        You may adjust the number of licenses.
      </b-card-text>
    </div>
    <b-list-group class="mt-2 rounded-0">
      <div class="mt-2 ml-2 mr-2"></div>
      <b-list-group-item class="bg-transparent">
        <b-form-group label="License count">
          <b-form-select v-model="quantity" :options="options"></b-form-select>
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item class="bg-transparent">
        <b-card-text class="h5 color-inherit text-reset">
          Calculator
        </b-card-text>
        <p>
          Cost per License: <b>{{ unitPrice }}</b>
        </p>
        <p>
          <b>{{ unitPrice }}</b> x <b>{{ quantity }} licenses</b> = <b>{{ totalPrice }}</b>
        </p>
      </b-list-group-item>
    </b-list-group>
    <template #footer="{ hide }">
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto cursor-pointer" @click="hide">Close</strong>
        <b-button size="sm" variant="primary" @click="onUpdate()">Update</b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState } from 'vuex'
import { BSidebar, BButton, BListGroup, BListGroupItem, BFormGroup, BFormSelect, BCardText } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSidebar,
    BListGroup,
    BCardText,
    BButton,
    BListGroupItem,
    BFormGroup,
    BFormSelect
  },
  directives: {
    Ripple
  },
  data() {
    return {
      quantity: 0,
      options: [{ value: 1, text: '1 user' }]
    }
  },
  computed: {
    ...mapState('billing', ['subscription', 'users', 'pricingDetails']),
    showModal: {
      get() {
        return this.$store.state.billingUpdateModal.showModal
      },
      set(value) {
        this.quantity = this.subscription.quantity
        this.options = []

        const priceDetails = this.pricingDetails.find(x => x.id === this.subscription.priceId)

        let minimumQuantity = parseInt(priceDetails.product.metadata.minimumQuantity)
        let maximumLicenses = parseInt(priceDetails.product.metadata.maximumLicenses)

        if (maximumLicenses > 100) {
          maximumLicenses = 100 // ToDo but for now
        }

        if (minimumQuantity < this.users.length) {
          minimumQuantity = this.users.length
        }

        for (let i = minimumQuantity; i <= maximumLicenses; i += 5) {
          this.options.push({ value: i, text: `${i} license${i > 1 ? 's' : ''}` })
        }
        this.$store.dispatch('billingUpdateModal/onChangeModal', { visible: value })
      }
    },
    unitPrice: {
      get() {
        const pricingDetail = this.pricingDetails.find(x => x.id === this.subscription.priceId)

        return `${pricingDetail.currency === 'usd' ? '$' : '£'} ${pricingDetail.unit_amount / 100}`
      }
    },
    totalPrice: {
      get() {
        const pricingDetail = this.pricingDetails.find(x => x.id === this.subscription.priceId)

        return `${pricingDetail.currency === 'usd' ? '$' : '£'} ${(pricingDetail.unit_amount / 100) * this.quantity}`
      }
    }
  },
  methods: {
    async onUpdate() {
      await this.$store.dispatch('billingUpdateModal/updateLicenseCount', { quantity: this.quantity })
      this.showModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
.list-group {
  text-align: start;
}
.list-group-item {
  border: none !important;
}

.btn-role {
  width: 100%;
}
</style>
